import styled from 'styled-components';
export const TableWrapper = styled.div `
  width: 100%;
  height: 100%;

  *:not(.ag-input-wrapper) {
    background-color: transparent;
  }

  .text-center {
    text-align: center;
  }

  .ag-root-wrapper {
    border: 1px solid ${({ theme }) => theme.getColor('gray', '05')};

    [role='row'] {
      &:not(:first-of-type) {
        border-bottom: 1px solid ${({ theme }) => theme.getColor('gray', '05')};
        &:hover {
          background-color: ${({ theme }) => theme.getColor('primary', 'light')};
        }
      }
    }
  }

  .ag-header {
    ${({ theme }) => theme.getFontStyle('samsung-700-14')}
    border-bottom: none;
    box-shadow: 0 1px 10px rgba(1, 41, 112, 0.1);
  }

  .ag-header-cell-label {
    display: flex;
    justify-content: center;
  }

  .ag-body {
    height: 100%;
  }

  .ag-menu,
  .ag-filter-wrapper {
    background-color: ${({ theme }) => theme.getColor('white')};
  }

  /* 필터 조건 드롭다운 메뉴 배경색 설정 */

  .ag-select-list {
    background-color: ${({ theme }) => theme.getColor('white')} !important;
    color: ${({ theme }) => theme.getColor('black')} !important;
  }

  [data-ref='eCheckbox'] {
    margin: 0 auto;
  }
`;
//# sourceMappingURL=AgGridTable.styles.js.map